import {
  getResumeRequestErrorCodeAndReason,
  useResumeRequestResponse,
} from '@aboutyou/user';

export const useIsCustomerSessionValid = () => {
  const {data, error, isLoading, isFetching} = useResumeRequestResponse();

  if (isLoading || isFetching) {
    return {
      isValidating: true,
      canAccessShop: true,
      canAccessCheckout: false,
    };
  }

  if (error) {
    const {errorCode} = getResumeRequestErrorCodeAndReason(error as Error);

    const shouldForceLogOut = errorCode === 9000;

    if (shouldForceLogOut) {
      return {
        isValidating: false,
        canAccessShop: false,
        canAccessCheckout: false,
      };
    }

    /**
     * ex: network error, we can allow the user to access the shop
     */
    return {
      isValidating: false,
      canAccessShop: true,
      canAccessCheckout: true,
    };
  }

  if (!data) {
    return {
      isValidating: false,
      canAccessShop: true,
      canAccessCheckout: false,
    };
  }

  return {
    isValidating: false,
    canAccessShop: true,
    canAccessCheckout: data.coSessionValid,
  };
};
